import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import VueElementLoading from 'vue-element-loading'
import CryptoJS from 'crypto-js'
import Pagination from './../shared/pagination'
export default {
	name: 'pickerassign',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		VueElementLoading
	},
	data() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			totalRowsFront: 0,
			// currentPage: 0,
			// getNewWarehouseData:'',
			listOrdersData: [],
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			orderid: "",
			fromDateFlt: "",
			toDateFlt: "",
			newActionMsg: "",
			modelMessage: "",
			// totalPage: 0,
			// pageNo: 0,
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			clientdata: [],
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			SelectPickerErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			batchCreationShow: false,
			cancelOrderId: [],
			loginuserid: '',
			searchchannel: '',
			channellist: [],
			pickerid: '',
			isLoading: false,
			pickerListData: '',
			//pageLimit: 10,

			selectAll: false,
			orderids: [],
			orderclass: '',
			batchmaxsize: '',
			batchminsize: '',
			defaultsize: '',
			defaultsizeOri: '',

		}
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);


		var roleids = userdetail.roleid.split(',');
		for (var i = 0; i < roleids.length; i++) {
			if (roleids[i] == 40) {
				this.purchasingManager = parseInt(userdetail.roleid);
				this.isTrue = true;
			}
		}
		this.loginuserid = userdetail.userid;
		this.pageNo = 0;

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client;
		if(this.clientid!=='undefined'){
			this.getSalesChannels();
		}	
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getconfig();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	}, // End computed
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatNew(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},

		selectAllCheckbox: function() {
			//this.rackIds = [];
			if (this.selectAll) {
				for (let order in this.listOrdersData) {
					if (this.orderids.indexOf(this.listOrdersData[order].orderid) == -1)
						this.orderids.push(this.listOrdersData[order].orderid);
				}
			} else {
				for (let order in this.listOrdersData) {
					if (this.orderids.indexOf(this.listOrdersData[order].orderid) >= 0)
						this.orderids.splice(this.orderids.indexOf(this.listOrdersData[order].orderid), 1);
				}
			}
		},
		resetAll: function(myAction) {
			if (myAction == 1) {
				this.orderids = [];
				this.selectAll = false;
			} else {}
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: this.warehouseid,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehousePickerList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getconfig();
		// 				//this.getOrderList();
		// 			}
		// 		}
		// 		this.orderids = [];
		// 	}
		// 	this.totalRows = 0;
		// 	this.listOrdersData = [];
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.listOrdersData = [];
		// 	this.pageNo = this.totalPage = 0;
		// 	this.totalRows = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getconfig();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.WarehouseErr = this.$t('common.clientError');
				return false;
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: this.clientid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		getOrderList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				orderid: this.orderid.trim(),
				fromddate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				saleschannel: this.searchchannel,
				orderclass: this.orderclass,

			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getOrderListForBatchCreation',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listOrdersData = result.data.data;

					if (result.data.errorCode == -1) {
						this.resultCount = 0;
					} else {
						this.totalRows = result.data.data.length;
						this.totalRowsFront = result.data.data.length;
						this.resultCount = result.data.data.length;
					}
					this.isLoading = false;
					this.totalRows = 0;
				}, error => {
					console.error(error)
				})
		},
		assignOrderToBatch() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.pickerAssignmentShow = false;
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}
			if (this.orderids == 0) {
				this.$alertify.error(this.$t('consolidation.selectAtLeastOneOrderErr'));
				return false;
			}
			if (this.defaultsize > this.batchmaxsize) {
				this.$alertify.error(this.$t('consolidation.defaultSizeErr'));
				return false;
			}
			if (parseInt(this.defaultsize) < parseInt(this.batchminsize)) {
				this.$alertify.error(this.$t('consolidation.defaultMinSizeErr'));
				return false;
			}
			this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				selectedorder: this.orderids,
				userid: this.loginuserid,
				batchsize: this.defaultsize,
			}
			//console.log(this.input);return false;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'createBatchForZonePicking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.batchCreationShow = false;
					//alert(this.defaultsizeOri);
					this.defaultsize = this.defaultsizeOri;
					document.getElementById('defaultsize').value = this.defaultsize;
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.batchCount);
						// this.$alertify.success(result.data.msg);
						this.$alert(result.data.msg, '', "success");
						this.getOrderList();

					} else if (result.data.errorCode === -2) {
						this.$alertify.success(result.data.batchCount);
						// this.$alertify.error(result.data.msg);
						this.$alert(result.data.msg, '', "error");
						this.getOrderList();
					} else {
						//this.$alertify.error(result.data.msg);
						this.$alert(result.data.msg, '', "error");
					}
					this.isLoading = false;
					this.selectAll = false;
					//this.pickerid = '';
					this.orderids = [];

				}, error => {
					console.error(error);
				});
		},

		getconfig() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getconfig',
					'data': {
						warehouseidlocal: this.warehouseid,
						localclientid: ''
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					this.setconfig(response.data, "batch");

				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		setconfig(response, moduleType) {

			if (moduleType == 'batch') {
				for (var i = 0; i < response.length; i++) {
					if (response[i].module == 'outbound' && response[i].type == 'batch') {
						this.batchmaxsize = response[i].maximumvalue;
						this.batchminsize = response[i].defaultval;
						this.defaultsize = response[i].maxval;
						this.defaultsizeOri = response[i].maxval;
					}
				}
			}

		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit
		// 	this.getOrderList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getOrderList()
		},
		getOrderSerach() {
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = true;
			this.getOrderList();
		},
		resetOrderSerach() {
			this.totalRows = 0;
			this.orderid = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.orderclass = '';
			this.searchchannel = '';
			this.listOrdersData = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.pickerid = '';
			this.orderids = [];
			this.totalRowsFront = 0;
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods
};


// WEBPACK FOOTER //
// ./src/views/components/batchCreation/batchCreation.component.js